import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { useTranslation } from "react-i18next";
import { Brand } from "../components/Brand";
import { ALTO_PANTALLA } from "../theme/theme";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: ALTO_PANTALLA,
        display: "grid",
        placeItems: "center",
        p: 3,
        bgcolor: "background.default",
      }}
    >
      <Stack
        spacing={3}
        sx={{ alignItems: "center", textAlign: "center", maxWidth: 420 }}
      >
        <Brand hero />
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            bgcolor: "action.hover",
            color: "text.secondary",
          }}
        >
          <SearchOffIcon fontSize="large" />
        </Box>
        <Typography variant="h2">{t("errors.pageNotFoundTitle")}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t("errors.pageNotFoundText")}
        </Typography>
        <Button
          component={RouterLink}
          to="/inicio"
          variant="contained"
          size="large"
        >
          {t("nav.home")}
        </Button>
      </Stack>
    </Box>
  );
}
